import { ErrorOutline } from '@mui/icons-material';

// Our class ui repo is overriding Alert styling, turning all alerts blue regardless of variant.
// This is a workaround to get the error alert to display correctly.

const alertStyles = {
    padding: '6px 16px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400'
};

const severityStyles = {
    error: {
        backgroundColor: 'rgb(253, 236, 236)',
        color: 'rgb(95, 26, 26)'
    }
};

const Alert = ({ severity = 'error', children }: { severity: 'error', children?: any }) => (
    <div style={{ ...alertStyles, ...severityStyles[severity] }}>
        <div style={{ display: 'flex' }}>
            <ErrorOutline
                style={{
                    color: '#EB1414',
                    marginRight: '12px',
                    marginTop: '6px'
                }}
            />
            <div style={{ padding: '8px 0' }}>
                {children}
            </div>
        </div>
    </div>
);

export { Alert };
